import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import './boxHeader.css';

import { useDispatch, useSelector } from 'react-redux';
import {
  eSIMStatus,
  getActiveInterface,
  getBoxCarrier,
  getBoxPower,
  getBoxVoltage,
  getIsBoxOnline,
  getSignalStrength,
  getPublicIP,
  getLanIP,
  getInterfacePriority
} from '../../../../actions/EpikBoxes';
import { useUnifiedFetch } from '../../../../hooks';
import SpinnerCircles from '../../../../components/Spinner/SpinerCircles';
import AddLocationModal from '../../../../components/AddLocationModal';
import { userRoles } from '../../../../utils/constants';
import socketIOClient from 'socket.io-client';
import { Button } from 'reactstrap';
import PingModal from '../../../../components/PingModal';
import utils from '../../../../lib/utils';
import InfoPopup from '../../../../components/InfoPopup';
import Heart from '../../../../Res/Icon/pulse.png';
import Signals from '../../../../components/Signals';
import activeCarrierImg from '../../../../Res/Icon/CarrierIcon.png';
import dataCenter from '../../../../Res/Icon/data_center.png';
import { ReactComponent as VoltageSvg } from '../../../../Res/Icon/Voltage.svg';
import { ReactComponent as TempSvg } from '../../../../Res/Icon/temp.svg';
import { ReactComponent as SimIcon } from '../../../../Res/svg/sim_card_icon.svg';
import { ReactComponent as BatteryChargingIcon } from '../../../../Res/Icon/battery_charging_icon.svg';
import {
  getSimCheckUtilities,
  getEpikBoxData
} from '../../../../actions/EpikBoxes';
import registeredIcon from '../../../../Res/Icon/registered_icon.png';
import { getPermissionForComponent } from '../../../../utils/permissionsUtils';

const {
  REACT_APP_LA_SHELL_URL,
  REACT_APP_CH_SHELL_URL,
  REACT_APP_NY_SHELL_URL,
  REACT_APP_AT_SHELL_URL,
  REACT_APP_DL_SHELL_URL,
} = process.env;
export const dataCenterShellUrls = {
  la: REACT_APP_LA_SHELL_URL,
  ch: REACT_APP_CH_SHELL_URL,
  ny: REACT_APP_NY_SHELL_URL,
  at: REACT_APP_AT_SHELL_URL,
  dl: REACT_APP_DL_SHELL_URL,
};
const DC_ABBR = {
  la: 'LOS ANGELES',
  ch: 'CHICAGO',
  ny: 'NEW YORK',
  at: 'ATLANTA',
  nypingavg: 'NY',
  dl: 'DALLAS',

};
const OFFLINE_TEXT = 'Edge Device Offline or Unreachable';
const isNA = (v) => String(v ?? '').trim().toLowerCase() === 'n/a';
const NO_DATA = `<span class="no-data">No Data</span>`;
const NO_DATA_TEXT = 'No Data'
const BoxCard = ({
  boxClass,
  onBoxClick = null,
  valueStyle,
  icon1,
  title,
  valueClass,
  value,
  pingButton,
  disablePing,
  onPing,
  testID,
  labelStyle,
  icon2 = {},
  subTitle = '',
  subTitleValue = '',
  subTitleStyle = '',
}) => {
  return (
    <div
      className={boxClass ? boxClass : `${value.loading ? 'boxPropertyloading ' : ''}boxProperty`}
      onClick={onBoxClick}
      id={`test-${testID ? testID : 'model'}`}
    >
      <div className="propertyNameContainer" id={`test-${testID ? testID : 'model'}-label`}>
        {icon1?.children ? (
          <>{icon1.children}</>
        ) : (
          <FontAwesomeIcon color="#ffffff" fixedWidth className="labelIcon" icon={icon1} />
        )}
        <span style={labelStyle} className="propertyName">
          {title}
        </span>
        {icon2?.children && <span id={`CustomerSIM${testID}`}> {icon2.children}
          <InfoPopup id={`CustomerSIM${testID}`} text={'Customer SIM'} infoIcon={false} />
        </span>}
        {value.loading && (
          <div style={{ marginRight: 10, marginTop: 10 }} class="loader">
            Loading...
          </div>
        )}
      </div>
      <div>
        <span
          className={valueClass ? `${valueClass}` : 'propertyValue'}
          id={`test-${testID ? testID : 'model'}-value`}
          style={{ display: 'flex', flexDirection: 'column', height: '100%', }}
        >
          {value?.value?.children ? (
            value?.value.children
          ) : (
            <span
                style={{ marginTop: 5, ...valueStyle, }}
              dangerouslySetInnerHTML={{ __html: value.value || '' }}
            />
          )}
          {pingButton && (
            <Button
              className="ping-btn"
              disabled={disablePing}
              onClick={() => onPing(value.value)}
              id={`test-${testID ? testID : 'model'}-ping-btn`}
            >
              <p>ping</p>
            </Button>
          )}
        </span>
      </div>
      {subTitle && subTitleValue && (
        <>
          <div className='propertyNameContainer'>
                <FontAwesomeIcon color="#ffffff" fixedWidth className="labelIcon" icon={icon1} />
            <span className="propertyName" style={{ ...labelStyle, ...subTitleStyle }} >
                  {subTitle}
                </span>
          </div>
          <div style={{ fontSize: 21, color: '#fff', fontWeight: 400 }}>
            <span
              style={{ marginLeft: 2, }}
                dangerouslySetInnerHTML={{ __html: subTitleValue || '' }}
              />
          </div>
            </>
      )}
    </div>
  );
};
const asText = (v) => {
  if (v == null) return 'N/A';
  const s = String(v).replace(/<[^>]*>/g, '').trim();
  if (!s || s.toLowerCase() === 'no data' || s.toLowerCase() === 'n/a') return 'N/A';
  return s;
};

const BoxCardDeisgn = (props) => {
  const {
    box = {},
    onBoxClick = () => {},
    valueStyle = {},
    valueClass = ''
  } = props;
  const isActiveInterfaceCard = box.title === 'Active Interface';
  return (
    <div className={props?.boxClass ? props.boxClass : 'boxProperty'} onClick={onBoxClick} id="test-model">
      <div className="propertyNameContainer justify-content-center" id="test-model-label">
        {box.icon1?.children ? (
          <>{box.icon1.children}</>
        ) : (
          <FontAwesomeIcon color="#ffffff" fixedWidth className="labelIcon" icon={box.icon1} />
        )}
        <span className="propertyName">{isActiveInterfaceCard ? 'Interface' : box.title}</span>
      </div>
      {isActiveInterfaceCard ? (
        <div className="dual-values">
          <div className="dual-column">
            <div className="dual-label">Priority</div>
            <div className="dual-value">{asText(box?.leftValue ? box?.leftValue : 'N/A')}</div>
          </div>  
          <div className="divider" />
          <div className="dual-column">
            <div className="dual-label">Active</div>
            <div className="dual-value">{asText(box?.rightValue ? box?.rightValue  : 'N/A')}</div>
          </div>
        </div>
      ) : (
        <span className={valueClass || 'propertyValue'} id="test-model-value" style={valueStyle}>
          {!box.value ? (
            <SpinnerCircles />
          ) : box?.value?.children ? (
            box.value.children
          ) : (
            <span dangerouslySetInnerHTML={{ __html: box.value }} />
          )}
        </span>
      )}
    </div>
  );
};
export default function ({ isBoxOnline }) {
  const token = localStorage.getItem('jwtToken') || null;
  const boxDetails = useSelector(state => state.AppState.boxDetails.box);
  const dispatch = useDispatch();
  const user = useSelector(state => state.AppState.user);
  const [addLocationModal, setAddLocationModal] = useState(false);
  const [pingRes, setPingRes] = useState([]);
  const [processId, setProcessId] = useState('');
  const [stateSocket, setStateSocket] = useState(null);
  const [disablePing, setDisablePing] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [esim, setEsim] = useState(false);
  const [publicIP, setPublicIP] = useState(null)
  const [lanIP, setLanIP] = useState(null)
  const [lanIPLoading, setLanIPLoading] = useState(false)
  const [data, setData] = useState({
    activeInterface: { loading: true, value: boxDetails.priorityInterface || NO_DATA },
    signals: { loading: true, value: { children: <Signals /> } },
    power: {
      loading: true,
      value: boxDetails?.powerState && !isNA(boxDetails.powerState)
        ? boxDetails.powerState
        : OFFLINE_TEXT,
    },
    // power: { loading: true, value: boxDetails.powerState || 'Edge Device Offline or Unreachable' },
    // carrier: { loading: true, value: boxDetails.activeCarrier  ? boxDetails.activeCarrier : NO_DATA },
    carrier: { loading: true, value: ''},
    devicePower: { loading: true, value: boxDetails.devicePower || boxDetails.power || NO_DATA },
    temp: { loading: true, value: boxDetails.cpuTemp || boxDetails.temp || NO_DATA },
    ispPriorityInterface: { loading: true, value: boxDetails.priorityInterface || boxDetails.priorityInterface || NO_DATA },
  });
  const [lteIpCheck, setLteIpCheck] = useState(null); 
  const [isLoadingLteIp, setIsLoadingLteIp] = useState(true); 

  const isESeries = boxDetails?.serialNumber && boxDetails?.serialNumber?.startsWith('E-')

  const {
    isLoading,
    data: batterPercentage,
    fetchData: fetchBatteryPercentage
  } = useUnifiedFetch(`boxes/${boxDetails?.vpnAddress}/battery-percentage`, false);

  const { _id, vpnAddress } = boxDetails;
  const {
    isLoadingData,
    data: lteIP,
    fetchData: lteIPData
  } = useUnifiedFetch(`/boxes/${_id}/simcheck?vpnAddress=${vpnAddress}`, false);
  
const onFetch = async () => {
  const { _id, vpnAddress } = boxDetails;
  if (!_id || !vpnAddress) {
    console.error('boxDetails is missing _id or vpnAddress');
    return;
  }
  try {
    // await dispatch(getSimCheckUtilities(token, _id, vpnAddress));
    await lteIPData(); // Triggers the fetch for LTE IP data
    await dispatch(getEpikBoxData(token, _id));
  } catch (error) {
    console.error('Error in fetching data:', error);
  }
};
const preferHtmlNoData = v =>
  (((v == null) || (typeof v === 'number') || (typeof v === 'string' && (!v.trim() || /^network carrier$/i.test(v.trim())))) && NO_DATA) || v;

  const boxStatus = (isBoxOnline, loading) => {
    if (loading) return `checking status`;

    return isBoxOnline ? 'Online' : 'Offline';
  };
  useEffect(() => {
    if (!isESeries) {
      //active interface
      dispatch(getActiveInterface(token, boxDetails._id, boxDetails.vpnAddress))
        .then(value => {
          setData(data => ({ ...data, activeInterface: { loading: false, value } }));
        })
        .catch(null);
        dispatch(getInterfacePriority(token, boxDetails.vpnAddress))
        .then(response => {
          setData(data => ({
            ...data,
            ispPriorityInterface: {
              loading: false,
              value: Array.isArray(response) ? response[0] : 'N/A'
            }
          }));
        })
        .catch(null);
      //Lan Ip
      if (!boxDetails?.customerProvidedIp) {
        setLanIPLoading(true)
        dispatch(getLanIP(token, boxDetails.vpnAddress))
          .then(value => {
            // sample output: {"if":"eth0","cidr":"192.168.3.128/22"}
            if (value) {
              let lanIP = value['cidr'];
              if (lanIP && (lanIP.toLowerCase().search('error') !== -1)) {
                lanIP = 'No Lan Connected'
              }
              setLanIP(lanIP);
            }
            setLanIPLoading(false)
          })
          .catch(null);
      }

      //public Ip / Egress IP
      if(user?.epikEngineering){
        dispatch(getPublicIP(token, boxDetails.vpnAddress))
          .then(value => {
            // sample output:{"Public IP":"98.153.169.2"}
            if (value) {
              const publicIP = value['Public IP'];
              setPublicIP(publicIP);
            }
          })
          .catch(null);
      }
      if (boxDetails.myEpik) return;
      // signal strength
      dispatch(getSignalStrength(token, boxDetails._id))
        .then(value => {
          setData(data => ({ ...data, signals: { ...data.signals, loading: false } }));
        })
        .catch(null);
      //box esim
      dispatch(eSIMStatus(token, boxDetails._id))
        .then(value => {
          setEsim(value);
        })
        .catch(null);
      //power state
      dispatch(getBoxPower(token, boxDetails._id))
        .then(value => {
          setData(data => ({
            ...data,
            power: { loading: false, value: value || OFFLINE_TEXT },
          }));
        })
        .catch(null);
      //carrier
      dispatch(getBoxCarrier(token, boxDetails._id))
        .then(value => {
          setData(data => ({
            ...data,
            carrier: { loading: false, value: value?.modemInfo?.networkCarrier ? preferHtmlNoData(value?.modemInfo?.networkCarrier) : NO_DATA },
          }));
          setLteIpCheck(value?.modemInfo?.lteIp);
          setIsLoadingLteIp(false); 
        })
        .catch(null);
      //power and volt
      dispatch(getBoxVoltage(token, boxDetails.vpnAddress))
        .then(value => {
          setData(data => ({
            ...data,
            devicePower: { loading: false, value: (value && value.power) || NO_DATA },
            temp: { loading: false, value: (value && value.temperature) || NO_DATA },
          }));
        })
        .catch(null);
  
      // if (boxDetails?.model === 'G4-4100' && data.power?.value === 'Battery') {
      //   fetchBatteryPercentage();
      // }
    }
    if (!boxDetails?.lteIp || !boxDetails?.lteIp2) {
      onFetch();
    }
  }, []);
  useEffect(() => {
    if (boxDetails?.model === 'G4-4100' && data?.power?.value === 'Battery') {
      fetchBatteryPercentage();
    }
  }, [boxDetails.powerState]);

  useEffect(() => {
    if (boxDetails?.powerState) {
      setData((prev) => ({
        ...prev,
        power: {
          loading: false,
          value: boxDetails.powerState
        }
      }));
    }
  }, [boxDetails.powerState]);

  const onPing = ip => {
    setDisablePing(true);
    const baseUrl = dataCenterShellUrls[boxDetails.datacenter];
    const socket = socketIOClient.connect(baseUrl, { query: { token } });
    console.log('CONNECTION SOCKET');
    socket.on('connect', () => {
      setStateSocket(socket);
      console.log('Successfully connected!');
    });
    const { serialNumber } = boxDetails;
    const serialNumberDash = `${serialNumber}-${user._id}`;
    console.log('[SOCKET] emit : ', ip);
    socket.emit('PING_REQUEST', { serialNumber: serialNumberDash, ip: ip, shouldStop: false });
    pingRequest(serialNumberDash, socket);
  };

  const handlePingClose = () => {
    console.log('[SOCKET] close : ', processId);
    const { serialNumber } = boxDetails;
    setIsOpen(false);
    if (stateSocket)
      stateSocket.emit('STOP_PING', { serialNumber: serialNumber, shouldStop: true, processId });
    setProcessId('');
    setPingRes([]);
    setDisablePing(false);
  };

  const pingRequest = (serialNumberDash, socket) => {
    console.log('[SOCKET] on : ', serialNumberDash);
    let ping = [];
    socket.on(serialNumberDash, data => {
      if (data.processId) {
        setProcessId(data.processId);
      } else {
        ping = [...ping, data.pingResponse];
        setPingRes(ping);
      }
    });
    setIsOpen(true);
  };

  const freeSwitchRegistration = () => {
    // if epikrest is not running then we set apiOnline to false
    if (!boxDetails.apiOnline) {
      return 'Unregistered';
    }
    return boxDetails.registered ? 'Registered' : 'Unregistered';
  }

  const boxMonitoring = () => (boxDetails.monitor ? 'Monitored' : 'Unmonitored');
  const handleSerialNumberClick = () => {
    const serialNumber = boxDetails.serialNumber || '';
    navigator.clipboard.writeText(serialNumber)
      .then(() => {
        console.log('Serial Number copied!');
      })
      .catch(err => {
        console.error('Failed to copy serial number: ', err);
      });
  };

  const secureInfo = getPermissionForComponent('secureInfo', user.permissionsGroup);

  return (
    <div style={{ width: '100%', ...(isESeries ? { display: 'flex', justifyContent: 'center' } : {}), }}>
      {
        isESeries ?
        <div className="boxOverviewContainer-e-series">
          <BoxCard
            icon1="map-marker-alt"
            title="Location Name"
            value={{ value: boxDetails?.locRef?.locationName || NO_DATA }}
            onBoxClick={() => setAddLocationModal(true)}
          />
          <BoxCard
            icon1="map-marker-alt"
            title="Serial Number"
            value={{ value: boxDetails.serialNumber || NO_DATA }}
            onBoxClick={handleSerialNumberClick}
          />
        </div> :
        <div className="boxOverviewContainer">
          {/* <BoxCard icon1="network-wired" title="Active Interface--" value={data.activeInterface} /> */}
            <BoxCardDeisgn
              box={{
                title: 'Active Interface',
                icon1: 'network-wired',
                leftValue: data.ispPriorityInterface.value ? data.ispPriorityInterface.value :  'N/A',
                rightValue: data.activeInterface.value ? data.activeInterface.value : 'N/A',
              }}
            />
          <BoxCard
            icon1="map-marker-alt"
            title="Location Name"
            value={{ value: boxDetails?.locRef?.locationName || NO_DATA }}
            onBoxClick={() => setAddLocationModal(true)}
          />
          <BoxCard
            icon1="map-marker-alt"
            title="Serial Number"
            value={{ value: boxDetails.serialNumber || NO_DATA }}
            onBoxClick={handleSerialNumberClick}
          />
          {(secureInfo === 'both' || secureInfo === 'read') && (
            <BoxCard
              icon1="network-wired"
                title="EPIK Edge Address"
              testID="epik-edge-address"
              value={{ value: boxDetails.vpnAddress }}
              pingButton={!!boxDetails.vpnAddress}
              onPing={onPing}
              disablePing={disablePing}
            />
          )}
          <BoxCard
            icon1="ethernet"
            // title={boxDetails.customerProvidedIp ? "Static IP Address" : "Public IP Address"}
            // title={"Lan IP Address"}   
            title={boxDetails?.e2?.enabled === false ? 'Lan IP Address' : 'Static IP Address'}
            testID="customer-provided-ip"
            valueStyle={{ fontSize: !(boxDetails.customerProvidedIp || lanIP) ? 17 : 22, marginTop: -5 }}
            value={{ value: boxStatus(isBoxOnline?.value, isBoxOnline?.loading) === 'Offline' ? NO_DATA_TEXT : boxDetails?.customerProvidedIp || lanIP, loading: lanIPLoading }}
            // pingButton={!!boxDetails?.customerProvidedIp}
            // onPing={onPing}
            // disablePing={disablePing}
             subTitle={user?.epikEngineering && 'EGRESS IP'}
             subTitleValue={user?.epikEngineering && publicIP}
           />
          {(secureInfo === 'both' || secureInfo === 'read') && (
            <>
              <BoxCard
                icon1="ethernet"
                title="LTE IP"
                testID="lte-ip"
                // value={{ value: boxDetails.lteIp || NO_DATA }}
                value={{ value: isLoadingLteIp ? boxDetails.lteIp : boxDetails.lteIp || NO_DATA, loading: isLoadingLteIp }}
                // pingButton={!!boxDetails.lteIp || !(boxDetails.modems?.length === 2 || !esim)}
                pingButton={
                  !isLoadingLteIp && 
                  (lteIpCheck?.trim() || '') === (boxDetails.lteIp?.trim() || '') && 
                  (!!boxDetails.lteIp || !(boxDetails.modems?.length === 2 || !esim)) 
                }
                onPing={onPing}
                disablePing={disablePing}
                icon2={{ children: boxDetails.customerProvideSIM1 ? <SimIcon width={20} height={20} /> : null }}
              />
              {!!boxDetails.lteIp2 && (
                <BoxCard
                  icon1="ethernet"
                  title="LTE IP 2"
                  testID="lte-ip-2"
                  // value={{ value: boxDetails.lteIp2 || NO_DATA }}
                  value={{ value: isLoadingLteIp ? boxDetails.lteIp2 : boxDetails.lteIp2 || NO_DATA, loading: isLoadingLteIp }}
                  // pingButton={!!boxDetails.lteIp2 || !(boxDetails.modems?.length === 2 || !esim)}
                  pingButton={
                    !isLoadingLteIp && 
                    (lteIpCheck?.trim() || '') === (boxDetails.lteIp2?.trim() || '') && 
                    (!!boxDetails.lteIp || !(boxDetails.modems?.length === 2 || !esim)) 
                  }
                  onPing={onPing}
                  disablePing={disablePing}
                  icon2={{ children: boxDetails.customerProvideSIM2 ? <SimIcon width={20} height={20} /> : null }}
                />
              )}
            </>
          )}
          <BoxCard
            icon1={{ children: <img src={Heart} alt="heart" className="labelIcon" /> }}
            title="Status"
            value={{ ...isBoxOnline, value: boxStatus(isBoxOnline?.value, isBoxOnline?.loading) }}
          />
          <BoxCard
            icon1={'wifi'}
            title="Signal Strength"
            value={data.signals}
            valueClass={'position-relative h-75 pb-1 d-flex justify-content-center'}
          />
          <BoxCard
            icon1={'power-off'}
            title="Power State"
            value={data.power}
            valueStyle={{ fontSize: data.power.value?.length > 10 ? '18px' : '32px' }}
          />
          <BoxCard
            icon1={{
              children: <img src={registeredIcon} fixedWidth className="labelIcon" alt={''} />,
            }}
            title="vSwitch"
            value={{ value: freeSwitchRegistration() }}
            valueStyle={{ fontSize: freeSwitchRegistration()?.length > 10 ? '24px' : '32px' }}
          />
          <BoxCard
            icon1={'bell'}
            title="Monitoring State"
            value={{ value: boxMonitoring() }}
            valueStyle={{
              fontSize: boxMonitoring().length > 10 ? '24px' : '32px',
            }}
          />
          <BoxCard
            icon1={{
              children: <img src={activeCarrierImg} fixedWidth className="labelIcon" alt={''} />,
            }}
            title="Active Carrier"
            value={data.carrier}
            valueStyle={{ fontSize: data.carrier.value?.length > 10 ? '20px' : '32px' }}
          />
          <BoxCard
            icon1={{
              children: <img src={dataCenter} fixedWidth className="labelIcon" alt={''} height={35} />,
            }}
            title="Active Data Center"
            value={{ value: DC_ABBR[boxDetails.datacenter] }}
            valueStyle={{ fontSize: DC_ABBR[boxDetails.datacenter]?.length > 10 ? '20px' : '32px' }}
          />
          <BoxCard
            icon1={{
              children: <VoltageSvg width={17} />,
            }}
            title="Device Power"
            value={data.devicePower}
            valueStyle={{
              fontSize: '32px',
            }}
          />
          <BoxCard
            icon1={{
              children: <TempSvg width={17} />,
            }}
            title="CPU Temp"
            value={data.temp}
            valueStyle={{
              fontSize: '30px',
            }}
          />
          {
            boxDetails?.model === 'G4-4100' && data?.power?.value === 'Battery'  && (
              <BoxCard
                icon1={{
                  children: <BatteryChargingIcon width={17} />,
                }}
                title="Battery Percentage"
                // value={{ value: batterPercentage && `${batterPercentage}%` || NO_DATA, loading: isLoading }}
                  value={{
                    value: isLoading
                      ? ""
                      : batterPercentage === null ||
                        batterPercentage === undefined ||
                        batterPercentage === ""
                        ? NO_DATA
                        : `${batterPercentage}%`,
                        loading: isLoading
                  }}
                valueStyle={{
                  fontSize: '30px',
                }}
              />
            )
          }
        </div>
      }      
      {boxDetails?.locRef && (
        <AddLocationModal
          disabled
          formData={boxDetails.locRef}
          isOpen={addLocationModal}
          onCancel={() => setAddLocationModal(false)}
        />
      )}
      {isOpen && <PingModal isOpen={isOpen} onCancel={() => handlePingClose()} data={pingRes} user={user} />}
    </div>
  );
}
